import React, { useState, useEffect, useContext } from 'react';
import { ParamsContext } from '../Context/ParamsContext';
import axios from '../../util/Api';
import { Card, Col, message, Row, Alert } from 'antd';
import Title from '../../components/Title/Title';
import General from './Detail/General';
import Skills from './Detail/Skills';
import Sickness from './Detail/Sickness';
import Training from './Detail/Training';
import Violation from './Detail/Violation';
import Verification from './Verification/Index';
import { useHistory } from 'react-router-dom';
import RfidCard from './Detail/RfidCard';
import RfidSetup from './Detail/RfidSetup';
import ProjectHistory from './Detail/ProjectHistory';
import { UserSwitchOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import InductionSchedule from './Verification/InductionSchedule';
import PassportQR from './Detail/PassportQR';

const Detail = (props) => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [passport, setPassport] = useState({});

  const { id } = useContext(ParamsContext);

  useEffect(() => {
    if (!id) history.push('/passport');
    fetchPassportDetail();
  }, []);

  const fetchPassportDetail = () => {
    setLoading(true);
    const url = `/passport/detail?id=${id}`;
    axios.get(url).then(resp => {
      setPassport(resp.data);
      setLoading(false);
    }).catch(err => {
      message.error("Gagal memuat data personel");
    });
  }

  window.reloadDetail = () => {
    fetchPassportDetail();
  }

  return (
    <>
      <Title>Detail Personel</Title>
      {loading ? "Sedang memuat data..." : <DetailContent passport={passport} />}
    </>
  );
}

export default Detail;

const DetailContent = ({ passport }) => {
  const [selected, setSelected] = useState({
    tab: 'Informasi Umum',
    key: 'general'
  });

  const tabList = [
    {
      key: 'general',
      tab: 'Informasi Umum',
    },
    {
      tab: 'Kompetensi',
      key: 'skills',
    },
    {
      tab: 'Riwayat Kesehatan',
      key: 'health',
    },
    {
      tab: 'Training',
      key: 'training'
    },
    {
      tab: 'Pelanggaran',
      key: 'violation'
    },
  ];

  const contentList = {
    general: <General passport={passport} />,
    skills: <Skills passport={passport} />,
    health: <Sickness passport={passport} />,
    training: <Training id={passport.id} />,
    violation: <Violation id={passport.id} />
  }

  return (
    <>
      <Row gutter={24}>
        <Col md={18} xs={24}>
          {passport.actions.waiting_for_verification ? <WaitingVerificationMessage /> : null}
          <Card
            className="gx-card"
            style={{ width: '100%' }}
            tabList={tabList}
            activeTabKey={selected.key}
            tabProps={{
              size: "middle"
            }}
            onTabChange={key => {
              setSelected(tabList.find(el => el.key === key));
            }}
          >
            {contentList[selected.key]}
          </Card>

          {passport.actions.switch_project ? <Link to={`/project/switch?id=${passport.id}`} className="ant-btn ant-btn-primary"><UserSwitchOutlined /> Pindah Proyek</Link> : null}

          <InductionSchedule passport={passport} />
          <Verification passport={passport} />
          <ProjectHistory passport={passport} />
        </Col>
        <Col md={6} xs={24}>
          {passport.rfid_number ? <RfidCard passport={passport} /> : <RfidSetup passport={passport} />}
          {passport.current_project.status.is_active ? <PassportQR passport={passport} /> : null}
        </Col>
      </Row>
    </>
  );
}

const WaitingVerificationMessage = ({}) => {
  return (
    <Alert type="info" message="Data sedang diverifikasi oleh QHSE Officer. Mohon kesediannya untuk menunggu." showIcon />
  );
}